import React, { useEffect, useState } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("reclaim_token")}` } });
const gbp = (v) => `£${(v || 0).toFixed(2)}`;

const openPdf = async (id) => {
  const r = await axios.get(`${API}/api/commissions/me/statements/${id}/pdf`, { ...auth(), responseType: "blob" });
  window.open(URL.createObjectURL(r.data), "_blank");
};

// Affiliate / Partner: earnings, balance owed, monthly statements.
export const AffiliateEarnings = () => {
  const [d, setD] = useState(null);
  useEffect(() => { axios.get(`${API}/api/commissions/me`, auth()).then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d?.approved) return null;
  const b = d.balance || {};
  return (
    <section className="mt-10 rounded-2xl border border-[#3a3f35] bg-[#141a17] p-5" data-testid="aff-earnings">
      {d.code && <p className="text-xs text-[#9fb39a]" data-testid="aff-earnings-link">Your link: {window.location.origin}/with/{d.code}</p>}
      <div className="mt-3 grid grid-cols-3 gap-3 text-center">
        {[["Earned", (b.earned || 0) + (b.reversed || 0)], ["Paid to you", b.paid], ["Owed now", b.outstanding]].map(([l, v]) => (
          <div key={l}><p className="text-[0.65rem] uppercase tracking-[0.2em] text-[#b9ad8f]">{l}</p><p className="mt-1 text-xl text-[#f3ecd9]">{gbp(v)}</p></div>
        ))}
      </div>
      <p className="mt-3 text-xs text-[#8f8a78]">Paid monthly once you're owed {gbp(d.min_payout_gbp)} or more. Smaller amounts carry forward.</p>
      {!!d.statements.length && (
        <ul className="mt-4 space-y-2 text-sm" data-testid="aff-statements">
          {d.statements.map((s) => (
            <li key={s.id} className="flex items-center justify-between text-[#cfc6ae]">
              <span>{s.ym} · {s.payout?.status === "paid" ? `${gbp(s.total_to_pay)} paid ${s.payout.paid_on}` : s.payable ? `${gbp(s.total_to_pay)} on its way` : `${gbp(s.carried_forward)} carried forward`}</span>
              <button type="button" onClick={() => openPdf(s.id)} className="text-xs text-[#d7bb7a] underline" data-testid={`aff-statement-pdf-${s.id}`}>{s.invoice_no ? "Invoice" : "Statement"}</button>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
};
